import React from 'react'
import { useQueryClient } from '@tanstack/react-query'
import RealTime from './RealTime'
import useDebouncedCallback from '@/v2/hooks/useDebouncedCallback'

const RTAppointments = ({ appointmentId }) => {
  const queryClient = useQueryClient()

  const handleEvent = useDebouncedCallback(() => {
    queryClient.invalidateQueries({
      queryKey: ['Appointment', `${appointmentId}`],
      cancelRefetch: true,
    })
    queryClient.invalidateQueries({
      queryKey: ['NextAppointments'],
      cancelRefetch: true,
    })
    queryClient.invalidateQueries({
      queryKey: ['DailyCalendar'],
      cancelRefetch: true,
    })
    queryClient.invalidateQueries({
      queryKey: ['WeeklyCalendar'],
      cancelRefetch: true,
    })
    queryClient.invalidateQueries({
      queryKey: ['PatientAppointments'],
      cancelRefetch: true,
    })
  }, 500)

  return (
    <RealTime
      channel="AppointmentChannel"
      onEvent={handleEvent}
      id={appointmentId}
    />
  )
}

export default RTAppointments
